import React, { useMemo } from 'react';
import type {
  IWRichTextProps,
  WRichTextBuilderProps,
} from '@wix/editor-elements-library/src/components/WRichText/WRichText.types';
import Component from '@wix/editor-elements-library/src/components/WRichText/viewer/WRichText';
import styles from './styles/WRichText.module.scss';

const WRichText: React.FC<
  Omit<WRichTextBuilderProps, 'html' | 'skin'>
> = props => {
  const memoizedProps = useMemo(() => {
    return {
      ...props,
      skin: 'WRichTextNewSkin',
      html: props.richText?.html || '',
      className: `${props.className || ''} ${styles.wrichtext} wrichtext`,
    } as IWRichTextProps;
  }, [props]);

  return <Component {...memoizedProps} />;
};

export default WRichText;
